import { cloneDeep } from 'lodash';
// 计算储备心率的区间值
export const countRHr = (restHr, maxHr, ratio) => {
  return (maxHr - restHr) * (ratio / 100) + restHr;
};

// 计算储备心率的区间百分比值
export const countRHrRatio = (restHr, maxHr, hr) => {
  return ((hr - restHr) / (maxHr - restHr)) * 100;
};
// 根据类型获取心率区间类型名称
export const getHrNameByHrType = (hrType) => {
  // 1：使用最大心率类型，2：使用储备心率类型，3: 乳酸阈心率类型
  const nameMaps = {
    1: 'maxHr',
    2: 'rhr',
    3: 'lthr'
  };
  return nameMaps[hrType] || '';
};
// 根据类型获取心率区间类型名称
export const getHrTypeByHrName = (hrName) => {
  // 1：使用最大心率类型，2：使用储备心率类型，3: 乳酸阈心率类型
  const nameMaps = {
    maxHr: 1,
    rhr: 2,
    lthr: 3
  };
  return nameMaps[hrName] || 0;
};
// 根据类型获取心率区间类型定义
export const getHrZoneOptionsByHrType = (hrType) => {
  const defaultHrZone = {
    maxHr: [
      {
        name: 'N1109',
        rename: 'N1109',
        color: '#00D2E6',
        ratioRange: [0, 50],
        type: 6
      },
      {
        name: 'G3038',
        rename: 'G3010',
        color: '#1199ee',
        ratioRange: [50, 60],
        type: 1
      },
      {
        name: 'G3039',
        rename: 'G3011',
        color: '#00ff44',
        ratioRange: [60, 70],
        type: 2
      },
      {
        name: 'G3043',
        rename: 'G3012',
        color: '#ffcc00',
        ratioRange: [70, 80],
        type: 3
      },
      {
        name: 'G3045',
        rename: 'G3013',
        color: '#ff9900',
        ratioRange: [80, 90],
        type: 4
      },
      {
        name: 'G3042',
        rename: 'G3014',
        color: '#ff0055',
        ratioRange: [90, 100],
        type: 5
      }
    ],
    rhr: [
      {
        name: 'G5019',
        rename: 'G5019',
        color: '#00D2E6',
        ratioRange: [0, 59],
        type: 6
      },
      {
        name: 'G3043',
        rename: 'G3010',
        color: '#1199ee',
        ratioRange: [59, 74],
        type: 1
      },
      {
        name: 'G3044',
        rename: 'G3011',
        color: '#00ff44',
        ratioRange: [74, 84],
        type: 2
      },
      {
        name: 'G3045',
        rename: 'G3012',
        color: '#ffcc00',
        ratioRange: [84, 88],
        type: 3
      },
      {
        name: 'G5016',
        rename: 'G3013',
        color: '#ff9900',
        ratioRange: [88, 95],
        type: 4
      },
      {
        name: 'G5017',
        rename: 'G3014',
        color: '#ff0055',
        ratioRange: [95, 100],
        type: 5
      }
    ],
    lthr: [
      {
        name: 'G5019',
        rename: 'G5019',
        color: '#00D2E6',
        ratioRange: [0, 80],
        type: 6
      },
      {
        name: 'G3048',
        rename: 'G3010',
        color: '#1199ee',
        ratioRange: [80, 90],
        type: 1
      },
      {
        name: 'G3049',
        rename: 'G3011',
        color: '#00ff44',
        ratioRange: [90, 95],
        type: 2
      },
      {
        name: 'G3050',
        rename: 'G3012',
        color: '#ffcc00',
        ratioRange: [95, 102],
        type: 3
      },
      {
        name: 'G5016',
        rename: 'G3013',
        color: '#ff9900',
        ratioRange: [102, 106],
        type: 4
      },
      {
        name: 'G5017',
        rename: 'G3014',
        color: '#ff0055',
        ratioRange: [106, ''],
        type: 5
      }
    ]
  };
  return defaultHrZone[getHrNameByHrType(hrType)] || [];
};
// 生产心率范围数据
export const getHrZone = (zoneData, hrType) => {
  let hadChange = false;
  const key = getHrNameByHrType(hrType);
  const zone = getHrZoneOptionsByHrType(hrType);

  let userZone = zoneData[`${key}Zone`];
  const userHr = zoneData[key] || 0;

  const isRHr = key === 'rhr';
  const isMaxHr = key === 'maxHr';

  let userZoneMap = {};
  const zoneMap = {};
  zone.forEach((item) => {
    zoneMap[item.type] = item;
  });
  if (userZone) {
    // userZone = userZone.slice(0, userZone.length - 1);
    userZone.forEach((item, index) => {
      const defaultItem = zone[item.index];
      const { type } = defaultItem;
      item.type = type;
      userZoneMap[type] = item;
    });
    Object.keys(userZoneMap).forEach((type) => {
      if (userZoneMap[type].ratio !== zoneMap[type].ratioRange[1]) {
        hadChange = true;
      }
    });
  }
  if (!Object.keys(userZoneMap).length) {
    userZoneMap = zoneMap;
  }
  const endZoneIndex = zone.length - 1;
  const hrZone = zone
    .map((item) => {
      // index 列表顺序
      const { type, name, color } = item;
      const { index } = userZoneMap[type];
      const result = {
        id: type,
        type,
        name: item[hadChange ? 'rename' : 'name'],
        defaultName: name,
        color
      };

      const addStart = ![0, endZoneIndex].includes(index);

      if (hadChange) {
        let startRadio = userZone[index - 1] ? userZone[index - 1].ratio : item.ratioRange[0];
        const endRadio = userZoneMap[type] ? userZoneMap[type].ratio : item.ratioRange[1];

        // 数值范围
        let start = (userHr * startRadio) / 100;
        let end = (userHr * endRadio) / 100;

        if (isRHr) {
          start = countRHr(zoneData.rhr, zoneData.maxHr, startRadio);
          end = countRHr(zoneData.rhr, zoneData.maxHr, endRadio);
        }

        if (addStart) {
          start = Number(start) + 1;
          startRadio++;
        }

        result.range = [start, end];
        result.ratioRange = [startRadio, endRadio];
      } else {
        // 使用系统默认范围
        result.ratioRange = item.ratioRange;
        if (isRHr) {
          result.range = [
            countRHr(zoneData.rhr, zoneData.maxHr, item.ratioRange[0]),
            countRHr(zoneData.rhr, zoneData.maxHr, item.ratioRange[1])
          ];
        } else {
          result.range = [Math.round((userHr * item.ratioRange[0]) / 100), Math.round((userHr * item.ratioRange[1]) / 100)];
        }

        if (addStart) {
          result.range[0] = Number(result.range[0]) + 1;
          result.ratioRange[0] = Number(result.ratioRange[0]) + 1;
        }
      }

      result.range = [Math.round(result.range[0]), Math.round(result.range[1])];

      result.rangeText = `${result.range[0]}-${result.range[1]}`;
      result.ratioRangeText = `${result.ratioRange[0]}%-${result.ratioRange[1]}%`;

      if (result.range[1] === '') {
        result.rangeText = `>${result.range[0]}`;
      }
      if (result.ratioRange[1] === '') {
        result.ratioRangeText = `>${result.ratioRange[0]}%`;
      }

      return result;
    })
    .filter((item) => {
      return !!item;
    });

  // 恢复区
  return cloneDeep(hrZone);
};
